import api from '~arithmetic/plugins/api';
import store from '~arithmetic/plugins/store';
import ui from '~arithmetic/plugins/ui';
import { getConfig } from '~arithmetic/utils';

const CONFIG = getConfig('{"updateLimit":true,"trackLimitUpdate":true,"getConfig":true,"type":"stl"}');

export default async function ArithmeticPlugin(ctx, inject) {
  const plugins = [api, store, ui];

  for (const plugin of plugins) {
    await plugin(ctx, inject, CONFIG);
  }
}
